<script setup>
  import {nextTick, ref} from "vue";

  import {MedCheckbox, MedFormField, MedLabel} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "PatientinputNonUnselectableCheckbox",
  });

  defineProps({
    color: {
      type: String,
      default: "default",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits(["click"]);

  const checkboxValue = ref(true);

  const handleChange = (isChecked) => {
    if (!isChecked) {
      emit("click");
      checkboxValue.value = false;
      nextTick(() => {
        checkboxValue.value = true;
      });
    }
  };
</script>

<template>
  <MedFormField orientation="horizontal" size="mobile">
    <MedCheckbox
      variant="primary"
      :model-value="checkboxValue"
      :disabled="disabled"
      :data-test="getTestId('non-unselectable-checkbox')"
      @change="handleChange"
    />
    <MedLabel :disabled="disabled">
      <slot />
    </MedLabel>
  </MedFormField>
</template>
